import './Loader.scss';

function Loader() {
  return (
    <div className="loader">
      <div className="loader__spinner" />
    </div>
  );
}

export default Loader;
